import type {
  VonqContractPostingRequirements,
  VonqPostingRequirementField,
  VonqProductPostingRequirements,
} from 'api-clients/monolith';

import type { VonqDetails } from '../../types';

export type PostingRequirementsDef = {
  key: string;
  source: 'contract' | 'product';
  sourceId: string;
  posting_requirements: VonqPostingRequirementField[];
};

export function requirementsKeyOf(
  vonqDetails: VonqDetails | null | undefined,
): string | null {
  if (!vonqDetails) return null;
  return vonqDetails.contractId ?? `product:${vonqDetails.productId}`;
}

export function contractDef(
  response: VonqContractPostingRequirements,
): PostingRequirementsDef {
  return {
    key: response.contract_id,
    source: 'contract',
    sourceId: response.contract_id,
    posting_requirements: response.posting_requirements,
  };
}

export function productDef(
  productId: string,
  response: VonqProductPostingRequirements,
): PostingRequirementsDef {
  return {
    key: `product:${productId}`,
    source: 'product',
    sourceId: productId,
    // Hire passes VONQ's product specs through as VONQ sends them, which omit
    // a facet's empty keys; the inputs and display rules read them as null.
    posting_requirements: response.posting_requirements.map(field => ({
      ...field,
      options: field.options ?? [],
      message: field.message ?? null,
      autocomplete: field.autocomplete ?? null,
      display_rules: field.display_rules ?? null,
      rules: field.rules ?? null,
    })),
  };
}
